import { UnderwritingActivityPostRequestBody, UnderwritingActivityPostResponse } from '@lio/api-types';
import { queryKeys } from './keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateUnderwritingActivity = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: UnderwritingActivityPostRequestBody) =>
      client
        .post(`underwriting-activity`, {
          json: {
            ...body,
          },
        })
        .json<UnderwritingActivityPostResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.underwritingActivity] });
    },
  });
  return { ...result, createUnderwritingActivity: result.mutateAsync };
};
